import React, { useMemo } from 'react';
import { useParams } from 'react-router-dom';

import {
  DxContainer,
  DxGrid,
  DxProcessHeader,
  DxSpacer,
} from '@dvag/design-system-react';
import { pages } from '@dvag/dfs-constant-config';
import { navigate } from '@dvag/dfs-orchestrator-client/messengers';
import i18next from 'i18next';

import { TopCard } from 'component/TopCard/TopCard';
import { LeftCard } from 'component/BottomCards/leftCard/LeftCard';
import { RightCard } from 'component/BottomCards/rightCard/RightCard';
import { useGetHouseholdDashboard } from 'hooks/useGetHouseholdDashboard';
import { AnalyseTopPagesData } from 'type/sectionList';
import { topSectionPageList } from './topPages.config';
import { BottomButtons } from 'component/BottomButtons/BottomButtons';
import { navigateToDocumentAppointmentOrKundenreportExport } from 'service/navigateToDocumentAppointment';
import '../AdvisoryDashboard/style.css';

export const AnalyseDashboard = () => {
  const { householdId } = useParams();
  const householdDashboard = useGetHouseholdDashboard();
  const personIdList = useMemo(
    () => (householdDashboard.data?.personList || []).map(({ id }) => id),
    [householdDashboard.data?.personList],
  );

  const goToPage = (page: AnalyseTopPagesData) => {
    if (!householdId) {
      return;
    }

    if (page.nextUrl) {
      navigate(page.getPath(householdId), page.nextUrl(householdId));
    } else {
      navigate(page.getPath(householdId));
    }
  };

  const navigateToNextSteps = () => {
    if (householdId) {
      navigate(pages.FIVE_STEPS.getUrl(householdId, true));
    }
  };

  const navigateToDocumentAppointment = () => {
    if (householdId) {
      navigateToDocumentAppointmentOrKundenreportExport(householdId, personIdList);
    }
  };

  if (householdDashboard.isLoading) {
    return null;
  }

  return (
    <>
      <DxProcessHeader headline={i18next.t('analyseDashboard.headline')} />
      <DxSpacer size="8v" />
      <DxContainer type="page" color="background">
        <DxGrid mq1="12/12/12/12" rowgap="24v">
          <DxGrid mq1="12/*" mq2="12/*" mq3="4-4-4">
            {topSectionPageList.map((item) => (
              <TopCard
                tag={item.id}
                key={item.id}
                title={item.displayValue}
                description={item.description}
                image={item.image}
                onClick={() => goToPage(item)}
                coverPosition={item.coverPosition}
              />
            ))}
          </DxGrid>

          <DxGrid mq1="12/*" mq3="6-6">
            <LeftCard showCoverageGaps={false} />
            <RightCard />
          </DxGrid>

          <BottomButtons
            navigateToNextSteps={navigateToNextSteps}
            navigateToDocumentAppointment={navigateToDocumentAppointment}
          />

          <DxSpacer size="8v" />
        </DxGrid>
      </DxContainer>
    </>
  );
};
